import { useState } from "react";
import { useNavigate } from "react-router-dom";
import BlogInfoCard from "../ui/BlogInfoCard";
import Input from "../ui/InputForm";
import Button from "../ui/Button";
import ButtonGroup from "../layout/ButtonGroup";
import { useAuth } from "../../context/AuthContext";
import { useMessages } from "../../context/MessageContext";

function BlogRight() {
  const { user } = useAuth();
  const { addMessage } = useMessages();
  const navigate = useNavigate();
  const [quickAddEmail, setQuickAddEmail] = useState("");
  const [quickAddError, setQuickAddError] = useState(null);

  const canQuickAdd = user?.role === "admin" || user?.role === "superadmin";

  const handleQuickAddCancel = () => {
    setQuickAddEmail("");
    setQuickAddError(null);
  };

  const handleQuickAddSubmit = () => {
    if (!canQuickAdd) {
      addMessage("error", "Je hebt geen rechten om gebruikers toe te voegen.");
      return;
    }

    const trimmed = quickAddEmail.trim().toLowerCase();
    if (!trimmed) {
      setQuickAddError("Vul een e-mailadres in.");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(trimmed)) {
      setQuickAddError("Voer een geldig e-mailadres in.");
      return;
    }

    setQuickAddError(null);
    addMessage("success", "Gebruiker toevoegen gestart.");
    navigate("/accounts", { state: { quickAddEmail: trimmed } });
  };

  return (
    <>
      <BlogInfoCard title="Meerdere domeinen?">
        <p>Gebruikt u ContinuMee binnen uw organisatie voor het meten van klantervaring binnen meerdere domeinen? Bijvoorbeeld Jeugdhulp, Wmo en Werk en Inkomen. Dan kunt u hieronder wisselen tussen de domeinen waar u als gebruiker aan gekoppeld bent.</p>
        <Input
          label="Kies domein"
          type="select"
          name="domain"
          placeholder="Kies domein"
          options={["Jeugdhulp", "Wmo", "Werk & Inkomen"]}
          onChange={() => { }}
        />
      </BlogInfoCard>

      <BlogInfoCard title="Trots op ContinuMee?">
        <p>Ben jij ook zo trots op het nieuwe platform ContinuMee? Deel het binnen jouw netwerk om de bekendheid te vergroten</p>
        <Input
          label="Deel link"
          type="text"
          value="www.continuemee.nl/usecases"
          readOnly
          copyable
        />
      </BlogInfoCard>

      {canQuickAdd && (
        <BlogInfoCard title="Voeg snel gebruikers toe" showicon={true} iconpath="add-user-line.png">
          <p>Wil je snel een gebruiker toevoegen?</p>
          <Input
            label="Email adres"
            type="email"
            name="inviteEmail"
            placeholder="E-mailadres"
            value={quickAddEmail}
            onChange={(event) => setQuickAddEmail(event.target.value)}
          />
          {quickAddError && (
            <p className="form-hint" style={{ color: "#d92d20" }}>
              {quickAddError}
            </p>
          )}
          <ButtonGroup>
            <Button variant="secondary" onClick={handleQuickAddCancel}>Annuleren</Button>
            <Button variant="primary" onClick={handleQuickAddSubmit}>Voeg toe</Button>
          </ButtonGroup>
        </BlogInfoCard>
      )}
    </>
  );
}

export default BlogRight;
